import { useEffect } from "react";
import { recordSocialEvent, recordGrowthVisitOnce } from "@/lib/siteEngagement";

// Keep lightweight visit analytics, but do not interrupt visitors with a donation modal.
export default function SiteEngagement() {
  useEffect(() => {
    // Keep legacy visit analytics, and separately count one unique visitor per browser
    // in the new growth-tracking period. Failed writes can retry on a later page load.
    const legacyKey = "yts:social:visit-recorded:v1";
    try {
      if (!window.localStorage.getItem(legacyKey)) {
        recordSocialEvent("visit")
          .then(() => { try { window.localStorage.setItem(legacyKey, "1"); } catch {} })
          .catch(() => {});
      }
    } catch {}
    recordGrowthVisitOnce();
  }, []);

  return null;
}
